import { ChangeDetectionStrategy, Component, DestroyRef, Input, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { DxTextAreaComponent } from "devextreme-angular";
import { DatePipe } from "@angular/common";
import { DemoInstance } from "../../../core";
import { getIntendedUseDescription, IntendedUseEnum } from "../../../core/model/IntendedUses";
import { DemoInstancesService } from "../../../services/demo-instances.service";

@Component({
  selector: "brd-instance-tile-info",
  templateUrl: "./instance-tile-info.component.html",
  styleUrl: "./instance-tile-info.component.less",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
  providers: [DatePipe]
})
export class InstanceTileInfoComponent implements OnInit {
  @ViewChild("textArea") textArea!: DxTextAreaComponent;
  @ViewChild("demoComposition", { read: TemplateRef, static: true }) demoCompositionTemplate!: TemplateRef<unknown>;
  @Input() instance!: DemoInstance;

  isEditing: boolean = false;
  popupInfo: { id: string; label: string; value: string; template?: TemplateRef<unknown> }[] = [];

  constructor(
    private instanceService: DemoInstancesService,
    private destroyRef: DestroyRef,
    private datePipe: DatePipe
  ) {}

  ngOnInit(): void {
    this.popupInfo = [
      {
        id: "creationDate",
        label: "creation date",
        value: this.instance.creationDate ? (this.datePipe.transform(this.instance.creationDate, "MM/dd/yyyy") as string) : "-"
      },
      {
        id: "expDate",
        label: "expiration date",
        value: this.instance.expirationDate ? (this.datePipe.transform(this.instance.expirationDate, "MM/dd/yyyy") as string) : "-"
      },
      { id: "region", label: "region", value: this.instance.regionName },
      {
        id: "type",
        label: "type & demos included",
        value: this.instance.templateSuggested ? `Suggested - ${this.instance.template}` : "Custom",
        template: this.demoCompositionTemplate
      },
      {
        id: "use",
        label: "intended use",
        value: this.instance.intendedUse !== null ? getIntendedUseDescription(this.instance.intendedUse) : "-"
      },
      {
        id: "comment",
        label: this.instance.intendedUse === IntendedUseEnum.opportunity ? "opportunity name" : "comment",
        value: this.instance.prospect ?? "-"
      }
    ];
  }

  undoNoteEdit(): void {
    this.isEditing = false;
    this.textArea.value = this.instance.comment;
  }

  saveNoteEdit(): void {
    this.isEditing = false;
    this.instanceService.updateNote(this.instance.id, this.textArea.value).pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
  }
}
